class VisualUtils {
  scaleImageElement(containerENode, imageElement, resizeMode) {
    const mode = resizeMode ?? "fill";
    const naturalWidth = imageElement.naturalWidth;
    const naturalHeight = imageElement.naturalHeight;
    const parentWidth = containerENode.props["size.width"];
    const parentHeight = containerENode.props["size.height"];
    const ratioWidth = parentWidth / naturalWidth;
    const ratioHeight = parentHeight / naturalHeight;

    let aspect = naturalWidth / naturalHeight;
    if (Number.isNaN(aspect)) aspect = 1;

    let x = 0, y = 0, width = 0, height = 0;
    switch (mode) {
      case "width": {
        width = parentWidth;
        height = parentWidth / aspect;
        y = (parentHeight - height) / 2;
        break;
      }
      case "height": {
        width = parentHeight * aspect;
        height = parentHeight;
        x = (parentWidth - width) / 2;
        break;
      }
      case "contain": {
        if (ratioWidth <= ratioHeight) {
          width = parentWidth;
          height = parentWidth / aspect;
          y = (parentHeight - height) / 2;
        } else {
          width = parentHeight * aspect;
          height = parentHeight;
          x = (parentWidth - width) / 2;
        }
        break;
      }
      case "fill":
      case "cover": {
        // fill/cover: Scale to fill container while maintaining aspect ratio
        // Excess will be clipped by container's overflow:hidden
        if (ratioWidth >= ratioHeight) {
          width = parentWidth;
          height = parentWidth / aspect;
          y = (parentHeight - height) / 2;
        } else {
          width = parentHeight * aspect;
          height = parentHeight;
          x = (parentWidth - width) / 2;
        }
        break;
      }
      default: {
        width = naturalWidth;
        height = naturalHeight;
        break;
      }
    }

    imageElement.width = width;
    imageElement.height = height;
    imageElement.style.translate = `${x}px ${y}px`;
  }

  scaleImage(parentCNode, imageCNode) {
    const naturalWidth = imageCNode.naturalWidth;
    const naturalHeight = imageCNode.naturalHeight;
    const parentWidth = parentCNode.props["size.width"];
    const parentHeight = parentCNode.props["size.height"];
    const ratioWidth = parentWidth / naturalWidth;
    const ratioHeight = parentHeight / naturalHeight;

    let aspect = naturalWidth / naturalHeight;
    if (Number.isNaN(aspect)) aspect = 1;

    let width,
      height = 0;
    switch (parentCNode.scaleContent) {
      case "width": {
        width = parentWidth;
        height = parentWidth / aspect;
        break;
      }
      case "height": {
        width = parentHeight * aspect;
        height = parentHeight;
        break;
      }
      case "contain": {
        if (ratioWidth <= ratioHeight) {
          width = parentWidth;
          height = parentWidth / aspect;
        } else {
          width = parentHeight * aspect;
          height = parentHeight;
        }
        break;
      }
      case "fill": {
        if (ratioWidth >= ratioHeight) {
          width = parentWidth;
          height = parentWidth / aspect;
        } else {
          width = parentHeight * aspect;
          height = parentHeight;
        }
        break;
      }
      case "cover": {
        if (ratioWidth >= ratioHeight) {
          width = parentWidth;
          height = parentWidth / aspect;
        } else {
          width = parentHeight * aspect;
          height = parentHeight;
        }
        break;
      }
      case "none": {
        width = naturalWidth;
        height = naturalHeight;
        break;
      }
      default: {
        width = parentWidth;
        height = parentHeight;
      }
    }

    imageCNode.width = width;
    imageCNode.height = height;
  }
}

const visualUtils = new VisualUtils();
export { VisualUtils, visualUtils };
